import { useFormik, FormikProvider } from 'formik';
import * as Yup from 'yup';
import ButtonWithLoader from '../../../../common/components/ui/loading/ButtonLoading';
import TextAreaFormik from '../../../../common/components/form/TextAreaFormik';
import InputFormik from '../../../../common/components/form/InputFormik';

type FormPropsAddNotesOperationalManagement = {
  onSubmit: (content: string, expectedResolutionDate: string) => Promise<{ ok: boolean, errors?: unknown[] }>;
  data,
  formRequestErrors?: { message: string, path: string[] }[]
};

const validationSchema = Yup.object({
  content: Yup.string().required('A observação é obrigatória.'),
});

function FormAddNotesOperationalManagement(props: FormPropsAddNotesOperationalManagement) {
  const formik = useFormik({
    initialValues: {
      content: props.data?.content || '',
      expectedResolutionDate: props.data?.expectedResolutionDate || '',
    },
    validationSchema,
    enableReinitialize: true,
    onSubmit: async (data) => {
      const result = await props.onSubmit(data.content, data.expectedResolutionDate)
      if (result.ok) {
        formik.setValues({
          content: '',
          expectedResolutionDate: '',
        });
      }
      return result
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <FormikProvider value={formik}>
        <div className="flex flex-col gap-4">
          <section>
            <div className="grid grid-cols-3 gap-2 mb-10">
              <div className="grid grid-cols-1 text-sm lg:text-lg col-span-3 gap-2">
                <div className="col-span-3">
                  <TextAreaFormik
                    label="Informe a Observação:"
                    name="content"
                    required={true}
                  />
                </div>
              </div>
            </div>
          </section>

            <section className='mt-2'>
            <InputFormik
              label={`Data prevista de resolução:`}
              name='expectedResolutionDate'
              type="date"
              min={new Date().toISOString().split('T')[0]}
            />
            </section>
        </div>
        <div className="w-full flex justify-end">
          <ButtonWithLoader isLoading={formik.isSubmitting} disabled={!formik.isValid} onClick={formik.handleSubmit}> Salvar </ButtonWithLoader>
        </div>
      </FormikProvider >
    </form >
  );
}

export default FormAddNotesOperationalManagement;